import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { MenuAction } from "./menu.action";
import { MenuState } from "./menu.model";

const INITIAL_STATE: MenuState = {
	isBusy: false,
	menus: {},
	notificationsCount: {},
	keysLoaded: [],
};
/**
 * @deprecated - [fabric-deprecated]
 */
export const menuReducer = createReducer(
	INITIAL_STATE,
	on(MenuAction.fetchAllByName, (state) => updateState(state, { isBusy: true })),
	on(MenuAction.fetchFail, (state) => updateState(state, { isBusy: false })),
	on(MenuAction.fetchSuccess, (state, { payload }) =>
		updateState(state, {
			menus: { ...state.menus, ...payload.menus },
			keysLoaded: [...state.keysLoaded, ...payload.keysLoaded],
			isBusy: false,
		})
	),
	on(MenuAction.setNotificationsCount, (state, { payload }) =>
		updateState(state, {
			notificationsCount: payload.menuItemKeys.reduce(
				(notificationsCount, key) => ({
					...notificationsCount,
					[key]: payload.count,
				}),
				state.notificationsCount
			),
		})
	)
);
